import { createCssCompNode } from '../cssCompNode'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import { withModes } from '../modesCompNode'
import { hasResponsiveLayout } from '../../utils/hasResponsiveLayout'
import { Component } from '@wix/thunderbolt-becky-types'
import { px } from '../../utils/selectorsUtils'

const VISIBILITY_HIDDEN = { visibility: 'hidden' } as const
const VISIBILITY_VISIBLE = { visibility: 'visible' } as const

const OVERRIDDEN_PROPS = ['isHiddenByModes' as const]

const getVisibility = (component: Component) => {
	// @ts-expect-error - isHiddenByModes is only checked here so we are not adding it to Component type
	return component.isHiddenByModes ? VISIBILITY_HIDDEN : VISIBILITY_VISIBLE
}

const hoverBox = createCompNode({
	getDependencies: () => null,
	toViewItem: (component) =>
		hasResponsiveLayout(component) || component.componentType === 'SiteRegionContainer'
			? undefined
			: getVisibility(component),
})
const editorHoverBox = createCompNode({
	getDependencies: () => null,
	toViewItem: (component) =>
		hasResponsiveLayout(component)
			? undefined
			: { ...getVisibility(component), height: `${px(component.layout.height)} !important` },
})

export const hoverBoxCss = createCssCompNode('hoverBoxCss', 'hoverBoxCss', withModes(hoverBox, OVERRIDDEN_PROPS))

export const editorHoverBoxCss = createCssCompNode(
	'hoverBoxCss',
	'hoverBoxCss',
	withModes(editorHoverBox, OVERRIDDEN_PROPS)
)
